export const getEuroFromCent = (cents: number) => cents / 100;
